export default "__VITE_ASSET__pZ_oy1yg__"